import { MinimalBoard } from "./board";

export const RECENT_BOARDS_SECTION_ID = "recent-boards";
export const MY_BOARDS_SECTION_ID = "my-boards";
export const SHARED_WITH_ME_SECTION_ID = "shared-with-me";
export interface BoardsSections {
  [key: string]: { boards: MinimalBoard[]; id: string };
}

export enum BoardSectionType {
  PROJECT = "PROJECT",
  WORKSPACE = "WORKSPACE",
  MY_BOARDS = "MY_BOARDS",
  RECENT = "RECENT",
  SHARED_WITH_ME = "SHARED_WITH_ME",
  TEMPLATES = "TEMPLATES",
}

export interface BoardSection {
  id: string | null;
  type: BoardSectionType;
  parentId?: string;
}

export const getSectionId = (type: BoardSectionType, id: string | null): string => {
  switch (type) {
    case BoardSectionType.MY_BOARDS: {
      return MY_BOARDS_SECTION_ID;
    }
    case BoardSectionType.RECENT: {
      return RECENT_BOARDS_SECTION_ID;
    }
    case BoardSectionType.SHARED_WITH_ME: {
      return SHARED_WITH_ME_SECTION_ID;
    }
    case BoardSectionType.WORKSPACE: {
      return `workspace-${id}`;
    }
    case BoardSectionType.PROJECT: {
      return `project-${id}`;
    }
    default: {
      return MY_BOARDS_SECTION_ID;
    }
  }
};
